import { render } from "./SystemSidebar.vue?vue&type=template&id=68ccfd67"
import script from "./SystemSidebar.vue?vue&type=script&lang=js"
export * from "./SystemSidebar.vue?vue&type=script&lang=js"

import "./SystemSidebar.vue?vue&type=style&index=0&id=68ccfd67&lang=css"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__